import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ImageOff, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const API = process.env.REACT_APP_BACKEND_URL;

/** Admin: delete employee-invoice header logos that no invoice or saved header uses any more. */
export const HeaderLogoCleanupCard = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/api/employee-invoices/header-logos/unused`);
      setStats(r.data);
    } catch {
      setStats(null);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const clean = async () => {
    setBusy(true);
    try {
      const r = await axios.delete(`${API}/api/employee-invoices/header-logos/unused`);
      toast.success(t('logoCleanup.removed', { count: r.data.removed }));
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || t('logoCleanup.failed'));
    } finally {
      setBusy(false);
    }
  };

  if (!stats) return null;
  return (
    <Card data-testid="header-logo-cleanup-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><ImageOff className="h-4 w-4" />{t('logoCleanup.title')}</CardTitle>
        <CardDescription>{t('logoCleanup.description')}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-slate-600" data-testid="header-logo-cleanup-count">
          {t('logoCleanup.status', { unused: stats.unused, total: stats.total })}
        </p>
        <Button variant="destructive" size="sm" disabled={busy || !stats.unused} onClick={clean} data-testid="header-logo-cleanup-btn">
          <Trash2 className="h-4 w-4 mr-1" />{busy ? t('logoCleanup.working') : t('logoCleanup.action', { count: stats.unused })}
        </Button>
      </CardContent>
    </Card>
  );
};

export default HeaderLogoCleanupCard;
